var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":_vm.activeMenuIndex,"mode":"horizontal","router":true},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"/"}},[_c('logo-bk',{attrs:{"width":"50","height":"50"}})],1),_vm._v(" "),_vm._l((_vm.menus),function(menu){return _c('menu-item',{key:menu.name,attrs:{"menu":menu}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64feca68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu.vue
// module id = hKKO
// module chunks = 1